module.exports = __webpack_public_path__ + "static/media/staff_anna_scislowska.23ac9624.png";